export function useDataEngine() {
    async function processDatabase(bytes: Uint8Array, autocorrection: boolean): Promise<any> {
        const form = new FormData()
        form.append('file', new Blob([bytes], { type: 'application/octet-stream' }), 'upload.db')
        form.append('autocorrection', String(autocorrection))

        return $fetch('/api/process-scan', {
            method: 'POST',
            body: form
        })
    }

    return { processDatabase }
}
